import { BIBME, CITATION_MACHINE, SiteState } from '@src/state/site/types'
import * as React from 'react'
import styled, { css } from 'styled-components'
import { default as PillBadgeBase, PillBadgeProps } from '../Badge'

interface CTAProps {
  site: SiteState
}

const PillBadge = styled(PillBadgeBase)<PillBadgeProps>`
  margin: 0 ${props => props.theme.spacing.sm};
`

const Link = styled.a<CTAProps>`
  margin-left: 40px;
  color: ${({ theme, site }) =>
    site === BIBME ? theme.colors.white : theme.colors.grey};
  text-decoration: none;
  white-space: nowrap;

  ${({ site }) =>
    site === BIBME
      ? css`
          font-weight: bold;
          font-family: 'Open Sans', sans-serif;
        `
      : ''}

  @media only screen and (max-width: 760px) {
    display: none;
  }
`

export const text = 'My papers'
const PapersCTA: React.FunctionComponent<CTAProps> = ({ site }) => (
  <Link href="/" site={site}>
    {site === BIBME && text}
    <PillBadge color="green4dc">NEW</PillBadge>
    {site === CITATION_MACHINE && text}
  </Link>
)

export default PapersCTA



// WEBPACK FOOTER //
// ./src/components/Header/PapersCTA.tsx